import React from 'react'
import styles from '../styles/Reviews.module.scss'

interface InTouchShortlyProps {
  firstName: string
  phone: string
}

export const InTouchShortlyStep: React.FC<InTouchShortlyProps> = ({ firstName, phone }) => {

  return (
    <div className={styles.thank_you}>
      <img src="/in-touch-shortly.svg" alt="In touch shortly"/>

      <p className={styles.thank_you_text}>
        Thank you {firstName}, <br/>
        we will reach out on {phone} <br/>
        as soon as possible.
      </p>
    </div>
  )
}